export default "__VITE_ASSET__9e173d1e__"